import React from "react"
import DropdownMenu from "./dropdownMenu"

export default props => {
  let { items, stringTemplate, taxonomy = {}, pageContext, block } = props
  const { pageType, vertical } = pageContext
  let _items = []

  let fallbackTitle
  switch (pageType) {
    case "provider":
      fallbackTitle = vertical?.name
      break
    case "taxonomyParent":
    case "taxonomyChild":
    case "taxonomyFilter":
      fallbackTitle = taxonomy?.name
      break
    default:
      break
  }

  const current = items?.find(i => i.current)

  if (stringTemplate) {
    items.forEach(item => {
      let title = stringTemplate?.replace("%NICHE", item.title)

      if (stringTemplate?.toLowerCase()?.indexOf(current?.title?.toLowerCase()) > -1) {
        const index = stringTemplate?.toLowerCase()?.indexOf(current?.title?.toLowerCase())
        title = stringTemplate.slice(0, index) + item?.title + stringTemplate.slice(index + current?.title?.length, stringTemplate.length);
      }

      if (pageType === "taxonomyFilter") {
        title = title.replace("%CATEGORY", taxonomy?.base?.name)
        title = title.replace("%FILTERCATEGORY", taxonomy?.filter?.name)
      } else {
        title = title.replace("%CATEGORY", taxonomy.name)
      }
      _items.push({ ...item, title: title, current: item?.current })
    })
  } else {
    _items = items
  }

  return <DropdownMenu className={"mb-3 " + (block ? "d-block" : "d-inline-block")} large title={_items?.find(i => i.current)?.title || fallbackTitle} menuItems={_items?.filter(i => !i.current)} />
}
